import React, { useState, useEffect } from "react";

import Form from "../../components/form/admin/Usuarios/grupos_permissoes";

import { getData, sendData } from "../../helpers/auth";
import { uriList } from "../../helpers/config";
import {
  DefaultOrder,
  sortByString,
  sortByNumber,
  compareDate,
} from "../../helpers/general";
import { swalError } from "../../components/swal";

function GruposPermissoes({ ...props }) {
  const [grupos, setGrupos] = useState([]);
  const [gruposC, setGruposC] = useState(null);
  const [total, setTotal] = useState(false);
  const [actualPage, setActualPage] = useState(0);
  const [filterOptions, setFilterOptions] = useState(false);
  const [modal, setModal] = useState(false);
  const [clickedTr, setClickedTr] = useState("");
  const [ascDesc, setAscDesc] = useState(true);
  const [grupo_filter, setGrupoFilter] = useState("");
  const [clear, setClear] = useState(false);
  const [loaded, setLoaded] = useState(true);

  // Busca todos os grupos ao abrir a tela
  useEffect(() => {
    getGruposC();
    getGrupos(true); // true para buscar todos ao abrir
    console.log("grupos_permissoes(useEffect)-View");
    // eslint-disable-next-line
  }, []);

  const handlePage = (e) => {
    setActualPage(e.currentTarget.value);
  };

  const createFilter = (obj) => {
    let newObj = {
      nome: [],
      descricao: []
    };

    for (let o of obj) {
      for (let i in o) {
        if (newObj[i]) {
          newObj[i].push(o[i]);
        }
      }
    }

    for (let i in newObj) {
      newObj[i] = [...new Set(newObj[i])];
    }

    setFilterOptions(newObj);
  };

  const getGruposC = async () => {
    const uri = uriList("gruposPermissoes");
    console.log("grupos_permissoes.getGruposC: ", uri);
    const content = {}
    try {
      const res = await sendData({ uri, content, method: "POST" });

      console.log("grupos_permissoes.getGruposC(res): ", res);
      if (res.status && res.status > 200) throw new Error();
      setGruposC(res?.data || res);
    } catch (e) {
      console.error(e);
    }
  };

  // Modificado: se all=true, busca todos os grupos, senão busca filtrado
  const getGrupos = (all = false) => {
    console.log("grupos_permissoes.getGrupos(all): ", { all, grupo_filter });
    // Se não for busca de todos, exige filtro
    // if (!all && !grupo_filter) {
    //   swalError("Informe um parâmetro para pesquisa");
    //   return;
    // }

    setLoaded(false);

    sendData({
      uri: uriList("gruposPermissoes"),
      content: all
        ? {
          actualPage: actualPage + 1,
          qtdLinesPage: 10,
        }
        : {
          grupo_filter: grupo_filter?.toUpperCase() || "",
          actualPage: actualPage + 1,
          qtdLinesPage: 10,
        },
      method: "POST"
    })
      .then((res) => {
        console.log("grupos_permissoes.getGrupos(res): ", res);
        if (res.status && res.status > 200) throw new Error();
        let grupos = (res?.data || res);

        console.log("grupos_permissoes.getGrupos(grupos): ", grupos);
        DefaultOrder(
          "grupos",
          (grupos)?.map((grupo) => grupo),
          setGrupos
        );
        setLoaded(true);
      })
      .catch((e) => {
        console.log("grupos_permissoes.getGrupos(error): ", e);
        setLoaded(true);
        return false;
      });
  };

  useEffect(() => {
    getGruposC();
    getGrupos(true); // Atualiza lista ao limpar
    // eslint-disable-next-line
  }, [clear]);

  const sortArrObj = (key, type) => {
    let arr = [...grupos];
    let asc = !ascDesc;

    arr = arr.sort((a, b) => {
      if (type === "string") {
        if (asc) {
          setAscDesc(asc);
          return sortByString(a, b, key, type);
        } else {
          setAscDesc(asc);
          return sortByString(b, a, key, type);
        }
      } else if (type === "numeric") {
        if (asc) {
          setAscDesc(asc);
          return sortByNumber(a, b, key, type);
        } else {
          setAscDesc(asc);
          return sortByNumber(b, a, key, type);
        }
      }
    });

    setGrupos(arr);
  };

  const handleGrupo = (e) => {
    let value = e.currentTarget.value;
    setGrupoFilter(value);
  };

  const handleClear = () => {
    setGrupoFilter("");
    setGrupos([]);
    setClear(!clear);
  };

  return (
    <>
      <Form
        filterOptions={filterOptions}
        setModal={setModal}
        setClickedTr={setClickedTr}
        clickedTr={clickedTr}
        sortArrObj={sortArrObj}
        grupos={grupos}
        gruposG={gruposC}
        actualPage={actualPage}
        handlePage={handlePage}
        total={total}
        handlePesquisar={getGrupos}
        context={props.context}
        handleGrupo={handleGrupo}
        grupo_filter={grupo_filter}
        handleClearOptions={handleClear}
        loaded={loaded}
        refresh={handleClear}
      />

      {modal}
    </>
  );
}

export default GruposPermissoes;
